<div class="container">
    <ng-container>
        <div class="ng-pristine ng-valid ng-touched">
            <textarea class="form-control ng-pristine ng-valid ng-touched"
                      [(ngModel)]="comment" (ngModelChange)="onChange()"
                      placeholder="Describe the changes you need" rows="4"></textarea>
            </div>
    </ng-container>
</div>